<template>
  <div class="wrapper">
    <v-head :headerType="''"></v-head>
    <div class="content-box" style="border: 10px solid red">
      <v-sidebar></v-sidebar>
      <!-- <v-tags></v-tags> -->
      <!-- <tagTwo></tagTwo> -->
      <div class="content-width">
        <div
          class="height"
          :style="
            'width: 70%; height: 100%; display: flex; min-height:' + heightPx
          "
        >
          <transition name="move" mode="out-in">
            <keep-alive :include="tagsList">
              <router-view
                :key="JSON.stringify(new Date().getTime())"
              ></router-view>
            </keep-alive>
          </transition>
        </div>

        <!-- <el-backtop target=".content"></el-backtop> -->
      </div>
    </div>
  </div>
</template>

<script>
import vHead from './Header.vue';
import vSidebar from './Sidebar.vue';
import vTags from './Tags.vue';
import bus from '../common/bus';
import tagTwo from '@/components/admin/all/tagTwo';
export default {
  data() {
    return {
      routerType: true,
      tagsList: [],
      collapse: true,
      heightPx: '100%',
    };
  },
  components: {
    vHead,
    vSidebar,
    vTags,
    tagTwo,
  },
  created() {
    bus.$on('collapse-content', (msg) => {
      this.collapse = msg;
    });

    // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
    bus.$on('tags', (msg) => {
      let arr = [];
      for (let i = 0, len = msg.length; i < len; i++) {
        msg[i].name && arr.push(msg[i].name);
      }
      this.tagsList = arr;
    });
    let width = document.body.clientWidth;
    this.heightPx = (820 / 1920) * width + 'px';
    window.onresize = () => {
      return (() => {
        var isFull =
          document.fullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement ||
          document.msFullscreenElement;
        if (isFull) {
          bus.$emit('quanping', true);
        } else {
          bus.$emit('quanping', false);
        }
        // 计算布局最小高度
        let width = document.body.clientWidth;
        this.heightPx = (820 / 1920) * width + 'px';
        // console.log(this.heightPx);
        // 重新定义px;
        if (document.documentElement.clientWidth < 1366) {
          document.documentElement.style.fontSize = 1366 / 1920 + 'px';
        } else {
          document.documentElement.style.fontSize =
            document.documentElement.clientWidth / 1920 + 'px';
        }
        // console.log(document.documentElement.clientWidth / 1920);
        // 触发所有当前echarts页面 重新渲染图表大小
        bus.$emit('echartsSize', '');
        // 重新渲染页面
        // this.routerType = false;
        // setTimeout(() => {
        //   this.routerType = true;
        // }, 30);
      })();
    };
  },
};
</script>

<style scoped lang="less">
.wrapper {
  background: url(~@/assets/img/content-bg.jpg) no-repeat;
  background-size: 100% 100%;
  // overflow-x: auto;
  /deep/.sidebar > ul > .el-submenu > .el-submenu__title {
    background: #1f3f75 !important;
    border-top: 1px solid #284f86;
    border-bottom: 0 px solid #284f86 !important;
  }
  /deep/.sidebar-el-menu .is-opened .el-submenu__title {
    background: transparent !important;
    // border-bottom: 1px solid #284f86 !important;
  }
  /deep/.sidebar-el-menu .el-menu-item.is-active,
  /deep/.sidebar-el-menu .el-menu-item:hover {
    background: transparent !important;
    color: #ffd200 !important;
  }
  .content-box {
    // display: flex;
    // position: relative;
    height: calc(100vh - 82px);
    overflow: ÷hidden;
  }
}

// @media screen and (min-height: 969px) {
//   .wrapper {
//     background: url(~@/assets/img/content-bg.jpg) no-repeat;
//     background-size: 100% 100%;
//   }
// }
</style>
